import { IExtendedContext } from '../../../../types/extendedContext';
import { updateDepositAccountPayment } from '../../../../../shared/ServicePickerWidget/actions/depositAccount';
import { checkPaymentStatus } from '../../../../../shared/ServicePickerWidget/thunks/payment/checkPaymentStatus';

import { PAYMENT_STATUS_ACTION } from './constants';
import { ECheckType, ICheckPaymentStatusHandlerParams } from './types';
import { EPaymentStatus } from '../../../../../shared/ServicePickerWidget/services/billingPayments';
import { changePlacingType } from '../../../../../shared/ServicePickerWidget/actions/publishTerms';

export const checkPaymentStatusHandler =
  (context: IExtendedContext) =>
  async (params: ICheckPaymentStatusHandlerParams): Promise<EPaymentStatus> => {
    const { paymentId, type, provider } = params;

    if (!paymentId) {
      return Promise.resolve(EPaymentStatus.Canceled);
    }

    const setStatusAction = PAYMENT_STATUS_ACTION[type];

    if (type === ECheckType.Package) {
      context.store.dispatch(changePlacingType(null));
    }

    context.store.dispatch(updateDepositAccountPayment({ paymentId, provider }));
    const result = await context.store.dispatch(checkPaymentStatus({ paymentId, provider, setStatusAction }));

    return result;
  };
